// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#TeamAllocation .TeamAllocation-items{display:flex;flex-direction:column;height:138px;justify-content:space-between}#TeamAllocation .TeamAllocation-items h4{color:var(--primary);font-size:15px;font-weight:600;margin:0}#TeamAllocation .TeamAllocation-items h1{color:var(--primary);font-size:35px;font-weight:700;margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
